import { UrlQuery } from "@nf/common";
import { useMemo } from "react";

import { useRouter } from "./useRouter";

export interface BingeQuery extends UrlQuery {
  collection?: string;
  playlist?: string;
}

export const useBingeQuery = (listQuery: UrlQuery = {}): BingeQuery => {
  const { query } = useRouter();

  const source = listQuery.collection || listQuery.playlist ? listQuery : query;

  const collection = source.collection?.toString();
  const playlist = source.playlist?.toString();

  return useMemo(() => ({ collection, playlist }), [collection, playlist]);
};
